import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import { API_HELPER } from "@/helpers/api.js";
import i18n from '@/helpers/i18n';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_API_GMAPS,
    libraries: 'places,drawing,visualization'
  },
  installComponents: true
})

router.beforeEach((to, from, next) => {
  // cancel pending requests and reset controller
  API_HELPER.abortController.abort();
  API_HELPER.abortController = new AbortController();

  // if logged out, process request
  const logoutPages = ['/logout'];
  if (logoutPages.includes(to.path)) {
    store.dispatch('users/logout', null, { root: true });
    return;
  }

  const loggedIn = localStorage.getItem('user');
  const publicPages = ['/login', '/reset-password'];

  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  // redirect to dashboard to dashboard if logged in and trying to acess logged out pages
  const authNotRequired = publicPages.includes(to.path);
  if (authNotRequired && loggedIn) {
    return next('/');
  }

  next();
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
